import BgPrice1 from 'assets/price-1.svg'
import BgPrice2 from 'assets/price-2.svg'
import BgPrice3 from 'assets/price-3.svg'
import BgPrice4 from 'assets/price-4.svg'
import BgPrice5 from 'assets/price-5.svg'
import { Theme } from 'styling/theme'
import { makeStyles } from '@material-ui/styles'

const priceImgSize = 60
const priceImgMarginRightMobile = 8
const priceImgMarginRightTabletAndDesktop = 16

export const useStyles = makeStyles((theme: Theme) => ({
    tierWrapper: {
        cursor: 'pointer',
    },
    item: {
        padding: '16px 12px',
        boxShadow: '0 2px 12px 0 rgba(0, 0, 0, 0.1)',
        backgroundColor: 'white',
        marginBottom: 16,

        '@media (min-width: 768px)': {
            padding: 16,
        },
    },
    soldOut: {
        opacity: 0.7,
        cursor: 'default',
    },
    radioDisabled: {
        cursor: 'default',
    },
    contentWrapper: {
        width: `calc(100% - ${priceImgSize}px - ${priceImgMarginRightMobile}px)`,
        alignSelf: 'center',

        '@media (min-width: 768px)': {
            width: `calc(100% - ${priceImgSize}px - ${priceImgMarginRightTabletAndDesktop}px)`,
        },
    },
    tierHeader: {
        display: 'flex',
        marginBottom: 8,
    },
    price1: {
        background: `url(${BgPrice1})`,
    },
    price2: {
        background: `url(${BgPrice2})`,
    },
    price3: {
        background: `url(${BgPrice3})`,
    },
    price4: {
        background: `url(${BgPrice4})`,
    },
    price5: {
        background: `url(${BgPrice5})`,
    },
    priceImg: {
        width: priceImgSize,
        height: priceImgSize,
        marginRight: priceImgMarginRightMobile,
        backgroundSize: 'cover',

        '@media (min-width: 768px)': {
            marginRight: priceImgMarginRightTabletAndDesktop,
        },
    },
    amountAndCheck: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    amount: {
        objectFit: 'contain',
        backgroundImage: 'linear-gradient(300deg, #fb7631, #fba916)',
        fontFamily: theme.typographyPresets.fonts.monserrat.bold,
        fontSize: 12,
        lineHeight: 1.67,
        letterSpacing: '1.03px',
        '-webkit-background-clip': 'text',
        backgroundClip: 'text',
        '-webkit-text-fill-color': 'transparent',
    },
    tierTitle: {
        fontFamily: theme.typographyPresets.fonts.monserrat.bold,
        objectFit: 'contain',
        fontSize: 16,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        color: '#13161a',
        marginBottom: 0,
    },
    tierDescriptionItems: {
        listStyle: 'none',
        paddingLeft: 0,
        fontFamily: theme.typographyPresets.fonts.monserrat.regular,
        fontSize: 12,
        fontWeight: 600,
        lineHeight: 2,
        color: theme.colors.light.darkgrey,
    },
    groups: {
        paddingLeft: 0,
        listStyle: 'none',
    },
    groupTitle: {
        fontFamily: theme.typographyPresets.fonts.notoSans.bold,
        fontSize: 14,
        lineHeight: 1.43,
        letterSpacing: 0.2,
        color: '#0e1117',
    },
    tierGroup: {
        paddingTop: 16,
        paddingBottom: 16,
        borderBottom: 1,
        borderBottomColor: '#d3d5db',
        borderBottomStyle: 'solid',

        '&:last-child': {
            borderBottom: 'none',
        },
    },
    img: {
        width: '100%',
    },
}))
